import { UseCase } from '@/domain/core/UseCase'
import { Result } from '@/domain/protocols/Result'

import type { IUserGeometryRepository } from '@/data/UserGeometryRepository/IUserGeometryRepository'

// File-level duplicate check on the imported file's original name (case-insensitive,
// soft-deleted rows ignored). Mirrors UserChart's dedup so the same KML/KMZ file cannot
// be imported twice; display-name uniqueness is handled by CheckUserGeometryNameExistsUseCase.
export class CheckUserGeometryFileExistsUseCase implements UseCase<string, Promise<Result<boolean>>> {
  constructor(private readonly repository: IUserGeometryRepository) {}

  async execute(originalFileName: string): Promise<Result<boolean>> {
    try {
      return await this.repository.existsByOriginalFileName(originalFileName)
    } catch (error) {
      return Result.fail(error)
    }
  }
}
